import React, { useEffect, useState } from 'react';
import { 
  Container, 
  Paper, 
  Typography, 
  Box, 
  CircularProgress,
  Button,
  Alert
} from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { API_URL } from '../config';

function VerifyEmail() {
  const [status, setStatus] = useState('pending');
  const [error, setError] = useState('');
  const { token } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email;

  useEffect(() => {
    if (token) {
      verifyEmail(token);
    }
  }, [token]);

  const verifyEmail = async (verificationToken) => {
    try {
      const response = await fetch(`${API_URL}/auth/verify-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token: verificationToken }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Verification failed');
      }

      setStatus('success');
      setTimeout(() => {
        navigate('/signin');
      }, 3000);
    } catch (err) {
      setStatus('error');
      setError(err.message);
    }
  };

  const resendVerification = async () => {
    try {
      const response = await fetch(`${API_URL}/auth/resend-verification`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to resend verification email');
      }

      setStatus('resent');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        {!token ? (
          <>
            <Typography variant="h5" gutterBottom>
              Verify Your Email
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              We've sent a verification email to <strong>{email}</strong>. 
              Please check your inbox and click the verification link.
            </Typography>
            <Button 
              variant="outlined" 
              onClick={resendVerification}
              disabled={status === 'resent'}
            >
              Resend Verification Email
            </Button>
            {status === 'resent' && (
              <Alert severity="success" sx={{ mt: 2 }}>
                Verification email has been resent!
              </Alert>
            )}
          </>
        ) : (
          <>
            {status === 'pending' && (
              <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                <CircularProgress />
              </Box>
            )}
            {status === 'success' && (
              <>
                <Typography variant="h5" gutterBottom sx={{ color: '#FFFFFF' }}>
                  Email Verified Successfully!
                </Typography>
                <Typography variant="body1">
                  Redirecting to sign in page...
                </Typography>
              </>
            )}
            {status === 'error' && (
              <>
                <Typography variant="h5" gutterBottom color="error">
                  Verification Failed
                </Typography>
                <Typography variant="body1" color="error">
                  {error}
                </Typography>
                <Button 
                  variant="contained" 
                  onClick={() => navigate('/signup')}
                  sx={{ mt: 2 }}
                >
                  Back to Sign Up
                </Button>
              </>
            )}
          </>
        )}
      </Paper>
    </Container>
  );
}

export default VerifyEmail; 